module.exports = __webpack_public_path__ + "img/registerimage4.08e7501f.png";